// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 274) return "static/chunks/274-3950c3c95ff7052e.js";
	if (chunkId === 150) return "static/chunks/150-9b212efa989cb86a.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"fa3cf3ca927423ef","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"b85d675de1714615","367":"1fe139c95c62d5d7","639":"cf9d73bb0d566e4a","748":"cf10d86e20c50e5d"}[chunkId] + ".js";
};